import React from 'react';
import { Container } from "react-bootstrap";
import { useData } from '../../context/DataContext';
import MaterialReactTableWithSearch from '../MaterialTable/MaterialReactTableWithSearch';
import Loading from '../Loading/Loading';

function Donations() {
    const { donationsData, loading, error, totalDonationsAmount } = useData();

    if (loading) return <Loading />;
    if (error) return <div style={{ padding: 24, color: 'red' }}>Error: {error}</div>;
    if (!donationsData) return <div style={{ padding: 24 }}>No donation data available.</div>;

    const columns = [
        { accessorFn: (row, index) => index + 1, header: 'SNO', id: 'id', size: 60 },
        { accessorKey: 'name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        {
            accessorKey: 'mobile', header: 'Mobile',
            Cell: ({ cell }) => {
                const n = cell.getValue();
                return <span>{n ? n.replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '-'}</span>;
            },
        },
        {
            accessorKey: 'amount', header: 'Amount',
            Cell: ({ cell }) => <span style={{ fontWeight: 600, color: 'var(--primary)' }}>${cell.getValue().toFixed(2)}</span>,
        },
        {
            accessorKey: 'inserted_time', header: 'Donated Date',
            Cell: ({ cell }) => {
                const d = new Date(cell.getValue());
                return <span>{d.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '')}</span>;
            },
        },
    ];

    return (
        <Container fluid className="px-0">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Donations</h1>
                    <p className="page-subtitle">{donationsData.length} donors &mdash; total raised</p>
                </div>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Total Raised</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--primary)', letterSpacing: '-0.02em' }}>${totalDonationsAmount}</div>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <MaterialReactTableWithSearch columns={columns} data={donationsData} />
            </div>
        </Container>
    );
}

export default Donations;
